function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

module.exports = _isNativeFunction;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/helpers/isNativeFunction.js
// module id = 661
// module chunks = 2